<template>
  <div>

    <section class="furniture_area p_120" id="dlealp_section_projects">
        <div class="container">
            <div class="main_title" v-html="content_section"></div>
            <!--div class="main_title">
                <h2>Alguns de nossos projetos</h2>
                <p>Projetos realizados pela D'lealp</p>
            </div -->
            <div class="furniture_inner row">
                
                <div class="col-lg-4" v-for="project in projects">
                    <div class="furniture_item"> <img class="img-fluid" :src="getFirstImageFromProject(project.id)" :alt="project.name">
                        <h4>{{project.name}}</h4>
                        <p>{{project.description}}</p>
                    </div>
                </div>
                
            </div>
            <br/>
            <br/>
            <div class="furniture_inner text-center"> <a class="main_btn" href="/projetos">Veja portfólio</a></div>
        </div>
    </section> 

  </div>
</template>

<script>

    import axios from 'axios';
    import {apiURL} from '../resources/apiUrl';
    let axiosInstance = axios.create();

    export default {
        
        name: 'RecenteProjects',

        props: {
            content_section: String,
        },
        
        data: function () {
            return {
                projects: [],
                imagesOfProjects: []
            }
        },

        created() {

            axiosInstance.get(`${apiURL()}/lp/projects?page=1&per_page=3`)
                .then(response => {
                    this.projects = response.data.data;
                    //Ao carregar projetos, busca imagens de cada um
                    this.projects.forEach(element => {
                        this.returnImagesFromProject(element.id);
                    });

                })
                .catch(error => {
                    console.log(error);
                })

        },

        methods: {
            
            returnImagesFromProject(id){
                axiosInstance.get(`${apiURL()}/lp/images/project/${id}`)
                    .then(response => {
                        this.imagesOfProjects.push(response.data);
                    })
                    .catch(error => {
                        console.log(error);
                    })
            },

            getFirstImageFromProject(projectId){

                let linkImage = null;

                this.imagesOfProjects.forEach( imageArray => {

                  imageArray.forEach( image => {
                      if(image.project.id == projectId) { 
                          if( linkImage == null ){
                              linkImage = image.link;
                          }
                      }
                  } );

                } );

                return `${apiURL()}/lp/images/${linkImage}`;
            }

        }
    }
  
</script>

<style>

</style>